const isDatabaseUrl = (value: string): boolean => /database\/\d+/.test(value);

export const getDatabaseIdFromString = (value: string): string | undefined => {
  if (isDatabaseUrl(value)) {
    const databasePattern = /database\/(\d+)/;
    const match = value.match(databasePattern);
    return match ? match[1] : undefined;
  }
};
